module.exports = __webpack_public_path__ + "static/media/download.0be152ba.svg";